<servicerapport-accordion-panel [formGroup]="formGroup" [title]="'Ejendommens noter'" (opret)="onOpret()">
    <note-liste
        #notePanel
        [formArray]="formArray"
        [omraader]="omraader"
        [henvendelsestyper]="henvendelsestyper"
        [opgavestyringStatusser]="opgavestyringStatusser"
        [brugere]="brugere"
        [defaultOmraadeId]="defaultOmraadeId"
        [autoGem]="true"
        [visOpretKnap]="false"
    >
    </note-liste>
</servicerapport-accordion-panel>
